const PRIMARY = 'primary';
const SECONDARY = 'secondary';
const YES = 'yes';
const addPositionToTrackingParam = (widgetArray) => (widgetArray.map((widget, index) => {
    const newWidget = widget;
    const trackingData = {
        position2: (index + 1),
    };
    newWidget.trackingData = Object.assign(Object.assign({}, widget.trackingData), trackingData);
    return newWidget;
}));
const shuffleChildren = (widgetArray) => {
    const finalArray = [];
    const randomPartOfArray = [];
    const randomPartIndices = [];
    widgetArray.forEach((widget, index) => {
        if (widget.params && (widget.params.randomize === YES)) {
            randomPartOfArray.push(widget);
            randomPartIndices.push(index);
        }
        else {
            finalArray.push(widget);
        }
    });
    let currentIndex = randomPartOfArray.length;
    let temporaryValue;
    let randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = randomPartOfArray[currentIndex];
        randomPartOfArray[currentIndex] = randomPartOfArray[randomIndex];
        randomPartOfArray[randomIndex] = temporaryValue;
    }
    randomPartIndices.forEach((item, index) => {
        if (randomPartOfArray[index]) {
            finalArray.splice(item, 0, randomPartOfArray[index]);
        }
    });
    return finalArray;
};
export const randomizeChildren = (widgetArray) => {
    if (!widgetArray) {
        return [];
    }
    if ((widgetArray.length > 1)
        && (widgetArray[0])
        && (widgetArray[0].params)
        && (widgetArray[0].params.randomize === undefined)) {
        return widgetArray;
    }
    let primary = [];
    let secondary = [];
    let other = [];
    widgetArray.forEach((widget) => {
        const section = widget.params ? (widget.params.section || PRIMARY) : (PRIMARY);
        switch (section) {
            case PRIMARY:
                primary.push(widget);
                break;
            case SECONDARY:
                secondary.push(widget);
                break;
            default:
                other.push(widget);
                break;
        }
    });
    primary = shuffleChildren(primary);
    secondary = shuffleChildren(secondary);
    other = shuffleChildren(other);
    const randomizedArray = [...primary, ...secondary, ...other];
    return addPositionToTrackingParam(randomizedArray);
};
export default randomizeChildren;
